// extracted by mini-css-extract-plugin
export default {"control":"control_control__6Euew","button":"control_button__HNaNS"};